import { cn } from "~/lib/cn";

interface UiOverlayProps {
  isOpen: boolean;
  onClick: () => void;
}

export function UiOverlay({ isOpen, onClick }: UiOverlayProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 bg-darkBg/50 z-[90] transition-opacity duration-300 backdrop-blur-sm",
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none",
      )}
      onClick={onClick}
      aria-hidden="true"
    />
  );
}
